<div class="stsdocs-page-header">
    <h2 class="stsdocs-page-header-title">Web Console</h2>
</div>

<div class="stsdocs-page-body">
    <div fxLayout fxLayoutAlign="center center" class="stsdocs-tabs-header">
        <mat-tab-group [(selectedIndex)]="selectedIndex" (selectedTabChange)="selectedTabChange($event)" animationDuration="0ms" mat-align-tabs="center" mat-stretch-tabs>
            <mat-tab *ngFor="let tab of tabs" [label]="tab.label"></mat-tab>
        </mat-tab-group>
    </div>

    <div *ngIf="tabs[selectedIndex]" class="stsdocs-tabs-body">
        <div class="stsdocs-tabs-body-content">
            <markdown [src]="tabs[selectedIndex].contentSrc"></markdown>
        </div>
    </div>
</div>
